import SkeletonCard from "@@/components/Loader/Skeleton/Card/skeletonCard";
import Box from "@@/elements/Box";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

export const multiRender = (amount: number, element: ReactNode) => [...Array(amount)].map((_, i) => <Box key={i}>{element}</Box>);

const CardsLoader = () => (
  <Box className={styles.cards_wrapper} mt={7}>
    {multiRender(9, <SkeletonCard variant="newsmodule" />)}
  </Box>
);

export default CardsLoader;
